import { HiOutlineReceiptRefund } from 'react-icons/hi';
import { MdOutlinePayments } from 'react-icons/md';

import useSWR from 'swr';

import { ResumeCard } from 'components';
import { integerToCurrency } from 'helpers';
import { useAuth } from 'hooks';
import { returnRequestService } from 'services';

export function ReturnRequestResume() {
  const { selectedStore } = useAuth();

  const { data, isLoading } = useSWR(
    `return-request-resume-${selectedStore.brand}-${selectedStore.name}`,
    returnRequestService.getResume
  );

  const quantity = data?.quantity || 0;
  const totalPrice = data?.totalPrice?.value || 0;

  return (
    <div className="flex flex-col gap-4">
      <p className="text-font16 font-bold text-neutral-500">
        Devoluções em aberto
      </p>
      <div className="flex flex-col md:flex-row gap-4">
        <ResumeCard
          icon={<HiOutlineReceiptRefund size={32} />}
          label="Devoluções pendentes"
          value={quantity}
          valueColor="text-neutral-500"
          isLoading={isLoading}
        />

        <ResumeCard
          icon={<MdOutlinePayments size={32} />}
          label="Valor total de devoluções pendentes"
          value={integerToCurrency(totalPrice, { removeCurrencySymbol: true })}
          valueColor="text-warning-500"
          isPrice
          isLoading={isLoading}
        />
      </div>
    </div>
  );
}
